/*  THE RESULTS PAGE UPDATES ITSELF. No reload, no spinner, no white flash.

    Typing in the dropdown already shows results without a page load. Landing on the
    results page and then changing the query did not: the form submitted, the page went
    white, and came back. That is the last full page load left in the search path, and it
    is the one that feels slowest because you have already seen results once.

    IT ASKS SHOPIFY TO RENDER THE SAME SECTION AGAIN rather than building cards in
    JavaScript. /search?q=...&section_id=ev-search returns this one section's markup and
    nothing else. That matters more than it looks: the card has a price rule, a free rule,
    a sold out rule and a bundle hover, and a second copy of all that in JavaScript would
    drift from the Liquid within a week. There is one card in this theme and it lives in
    ev-card.liquid.

    THE FORM IS NEVER REPLACED. Only the title, the sub line and the results body swap.
    Replacing the field somebody is mid sentence in takes their caret and their focus with
    it, and on a phone it closes the keyboard.

    THE OLD RESULTS STAY ON SCREEN WHILE THE NEW ONES ARE FETCHED, dimmed slightly. This
    is the whole point. Blanking the grid and showing a spinner would be a loading state
    for a request that usually takes under 200ms, and a flash of nothing reads as slower
    than a brief dim, even when it is not.

    ONE REQUEST WINS. Typing is faster than the network, so responses can land out of
    order. Each request carries a sequence number and anything stale is dropped, otherwise
    searching for "coding" can end up showing the results for "codi".

    THE URL KEEPS UP, with replaceState rather than pushState. Every keystroke pushing
    history would mean the back button walks you through "c", "co", "cod" one letter at a
    time before it leaves the page. The address bar stays correct and shareable; the back
    button still does what a person expects, which is to leave.

    IT DEGRADES TO THE FORM. No JavaScript, a failed fetch, an old browser: the form is a
    real GET to the search route and still works. The catch below falls back to submitting
    it rather than leaving somebody staring at results for a query they have changed.  */
(function () {
  'use strict';

  var root = document.querySelector('[data-ev-sr]');
  if (!root || !window.fetch) return;

  var form  = root.querySelector('[data-ev-sr-form]');
  var input = root.querySelector('[data-ev-sr-input]');
  var title = root.querySelector('[data-ev-sr-title]');
  var sub   = root.querySelector('[data-ev-sr-sub]');
  var body  = root.querySelector('[data-ev-sr-body]');
  if (!form || !input || !body) return;

  var seq = 0, timer = null, last = input.value.trim();

  function apply (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var t = doc.querySelector('[data-ev-sr-title]');
    var s = doc.querySelector('[data-ev-sr-sub]');
    var b = doc.querySelector('[data-ev-sr-body]');
    if (t && title) title.innerHTML = t.innerHTML;
    if (s && sub)   sub.innerHTML   = s.innerHTML;
    if (b)          body.innerHTML  = b.innerHTML;
    body.classList.remove('is-updating');
    /*  The new cards are new elements, so the bundle hover has to be bound again. Both
        scripts are written to be safe to run twice.  */
    if (window.evRebind) window.evRebind();
  }

  function run (q) {
    var mine = ++seq;
    body.classList.add('is-updating');

    var url = '/search?q=' + encodeURIComponent(q) + '&type=product&section_id=ev-search';
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        if (mine !== seq) return;                       // a newer keystroke already won
        apply(html);
        var clean = '/search?q=' + encodeURIComponent(q);
        history.replaceState({ q: q }, '', q ? clean : '/search');
      })
      .catch(function () {
        if (mine !== seq) return;
        form.submit();                                  // let the browser do it properly
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var q = input.value.trim();
      if (q === last) return;
      last = q;
      run(q);
    }, 220);
  });

  /*  Enter would otherwise reload the page it is already on.  */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(timer);
    var q = input.value.trim();
    last = q;
    run(q);
    input.blur();                                       // closes the keyboard on a phone
  });
})();
